import { POST } from '@/server/http';
import URLS from '@/server/urls';
export default async ({
    username,
    password,
    verifyCode,
    verCodeId,
}, options = { showError: true }) => {
    const [ content, error, status ] = await POST(URLS.admin.adminLogin, {
        username,
        password,
        verifyCode,
        verCodeId,
    }, options);
    if (error) return { error, status };
    return { ...content };
};

